import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { GtmService } from '@app/services/integrations/gtm/gtm.service';
import { GTM_ENABLED, GTM_WORKSPACE_ID } from '@app/services/integrations/gtm/gtm.tokens';

export function provideGtm(workspaceId: string, enabled: boolean): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: GTM_WORKSPACE_ID, useValue: workspaceId },
    { provide: GTM_ENABLED, useValue: enabled },
    GtmService,
  ]);
}
